import React from "react";
import styles from "../HomePage.module.css";
import { highlightGoldCoast } from "../../../utils/highlightGoldCoast";

// Data with your local file paths
const amenityItems = [
  {
    id: 1,
    title: "Comfortable Motel Rooms",
    desc: "Enjoy clean, comfortable and well-maintained motel rooms in Tweed Heads South, NSW, ideal for couples, families and travellers.",
    imageSrc: "/images/ARB. 2.jpg",
  },
  {
    id: 2,
    title: "Convenient Tweed Heads South, NSW Location",
    desc: "Stay close to Tweed Heads South, NSW town centre, local attractions, shops, restaurants and major roads for easy travel around the Tweed Valley.",
    imageSrc: "/images/ARB. 7.jpg",
  },
  {
    id: 3,
    title: "Free On-Site Parking",
    desc: "Enjoy convenient free parking in Tweed Heads South, NSW with easy access to your room, making your stay simple and hassle-free.",
    imageSrc: "/images/img2.jpg",
  },
  {
    id: 4,
    title: "Free High-Speed Wi-Fi",
    desc: "Stay connected with free Wi-Fi throughout your stay, whether you're travelling for business or leisure.",
    imageSrc: "/images/ARB. 10.jpg",
  },
  {
    id: 5,
    title: "Friendly Local Service",
    desc: "Our friendly team is here to make your Tweed Heads South, NSW accommodation experience comfortable, convenient and welcoming.",
    imageSrc: "/images/ARB. 8.jpg",
  },
];

// Single Item Component (Pill with description)
const AmenityPill = ({ item }) => {
  return (
    <div className={styles.amenityWrapper}>
      {/* The Vertical Pill Shape */}
      <div className={styles.mediaShape}>
        <img
          className={styles.amenityVideo}
          src={item.imageSrc}
          alt={item.title}
          loading="lazy"
        />
      </div>

      {/* Text Content Below */}
      <div className={styles.textContent}>
        <h3 className={styles.itemTitle}>{item.title}</h3>
        <p className={styles.itemDesc}>{highlightGoldCoast(item.desc)}</p>
      </div>
    </div>
  );
};

// Main Section Component
const VideoAmenitiesSection = () => {
  return (
    <section className={styles.videoAmenitiesSection}>
      {/* Header Section */}
      <div className={styles.amenitiesHeader}>
        <h2 className={styles.amenitiesTitle}>
          Comfortable Accommodation <span className={styles.playText}>in Tweed Heads South, NSW</span>
        </h2>
        <p className={styles.amenitiesSub}>
          {highlightGoldCoast(
            "Relax, stay comfortable and enjoy convenient accommodation in the heart of Tweed Heads South, NSW — ideal for travellers looking for a motel near Murwillumbah, Tweed Heads accommodation and a Northern Rivers coastal stay."
          )}
        </p>
        <a className={styles.exploreBtn} href="https://book-directonline.com/properties/southtweedmidirect" target="_blank" rel="noopener noreferrer">Book Your Stay</a>
      </div>

      {/* The Row of Pills */}
      <div className={styles.amenitiesRow}>
        {amenityItems.map((item) => (
          <AmenityPill key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
};

export default VideoAmenitiesSection;
